/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import { CTAContentfulForHero } from 'bundles/coursera-plus-landing-page/components/ctaContentful/CTAContentful';
import CourseraLiteLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraLiteLogo';
import CourseraPlusLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraPlusLogo';
import HeroText from 'bundles/coursera-plus-landing-page/components/heroContentful/HeroText';
import { HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE } from 'bundles/coursera-plus-landing-page/contentful/constants';

export type DesktopImageProps = {
  imageUrl?: string;
};

const styles = {
  desktopContainer: (slug?: string) => css`
    max-width: 1200px;
    margin: ${slug !== HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE ? '20px auto' : '0 auto'};
    padding: ${slug !== HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE ? '20px' : '0 20px'};
  `,

  rightContainer: (slug?: string) => css`
    ${slug === HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE
      ? `
    padding: 0 16px !important;
    margin: -5px 0 !important;
    `
      : ''}
  `,
};

type LegacyProps = { isCourseraLiteContentfulPage: boolean; slug?: string };

// The layout our Yellow Dots and YesICan side by side design share

const LegacyDesktop: React.LegacyFunctionComponentWithChildren<LegacyProps> = (props) => {
  const { slug } = props;
  return (
    <div css={styles.desktopContainer(slug)}>
      <Grid container direction="row" alignItems="stretch" spacing={32} wrap="nowrap">
        <Grid item container direction="column" justifyContent="space-around">
          {props.isCourseraLiteContentfulPage ? <CourseraLiteLogo /> : <CourseraPlusLogo />}
          <HeroText />
          <CTAContentfulForHero />
        </Grid>
        <Grid item css={styles.rightContainer(slug)}>
          {/* image(s) on the right side */}
          {props.children}
        </Grid>
      </Grid>
    </div>
  );
};

export default LegacyDesktop;
